// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"checklist_mainContainer__wKEGf","illustration":"checklist_illustration__3qnkb"};